<homey-text-page ngSkipHydration>
  <div>
    <homey-page-title-layout>
      Common questions
    </homey-page-title-layout>
    <homey-page-subtitle title="What is the NYC Housing Lottery?"/>
    <p>The NYC Housing Lottery is a city-run program that offers a chance to secure <span class="font-medium">a brand-new, rent-stabilized apartment</span> at an affordable rate.</p>
  </div>
  <div>

    <homey-page-subtitle title="How much can I save on rent?"/>
    <p>Families typically save <span class="font-medium">$1,000 to $1,200 per month</span> compared to similar apartments. Plus, with rent stabilization, rent increases are limited over time.</p>
  </div>
  <div>
    <homey-page-subtitle title="Do I qualify?"/>
    <p>
      Affordable housing through the NYC Housing Lottery isn’t just for low-income households — it’s open to a <span class="font-medium">wide range of incomes</span>. Eligible household incomes typically range from <span class="font-medium">$30,000 to $240,000 per year</span>.
    </p>
  </div>
  <div>
    <homey-page-subtitle title="What does Homey do?"/>
    <p>
      Homey automates the entire NYC Housing Lottery process for you:
    </p>
    <ul class="pl-5 list-disc mt-4 flex flex-col gap-1">
      <li><span class="font-medium">Tracks</span> every new lottery opportunity</li>
      <li><span class="font-medium">Matches</span> you to all lotteries you qualify for</li>
      <li><span class="font-medium">Applies</span> on your behalf</li>
      <li><span class="font-medium">Follows</span> up to ensure nothing falls through the cracks</li>
      <li><span class="font-medium">Notifies</span> you the moment you win!</li>
    </ul>
  </div>
  <div>
    <homey-page-subtitle title="What do I have to do?"/>
    <p>
      Getting started is easy! Just answer a few quick questions about your <span class="font-medium">income, family size, and housing preferences — and we’ll apply to every lottery you qualify for in just 10 minutes.</span>
    </p>
  </div>
  <div>
    <homey-page-subtitle title="Do you run the housing lottery?"/>
    <p>
      We're not affiliated with the city or he official lottery system. We just make the process easier by managing all the paperwork for you.
    </p>
  </div>
</homey-text-page>
<homey-lotteries-and-footer/>
